import React from "react";
import PushNotifications from "../pages/notifications/push/PushNotifications";
import Promotions from "../pages/notifications/promotions/Promotions";
import PromoDetails from "../pages/notifications/promotions/PromoDetails";
import CreatePromo from "../pages/notifications/promotions/CreatePromo";
import EditPromo from "../pages/notifications/promotions/EditPromo";
import Announcements from "../pages/notifications/announcement/Announcements";
import AnnouncementDetails from "../pages/notifications/announcement/AnnouncementDetails";
import CreateAnnouncement from "../pages/notifications/announcement/CreateAnnouncement";
import EditAnnouncement from "../pages/notifications/announcement/EditAnnouncement";

export const notificationRoutes = [
  {
    path: "/notifications/push-notifications",
    element: <PushNotifications />,
  },
  {
    path: "/notifications/promotions",
    element: <Promotions />,
  },
  {
    path: "/notifications/promotions/:promotionId",
    element: <PromoDetails />,
  },
  {
    path: "/notifications/promotions/create",
    element: <CreatePromo />,
  },
  {
    path: "/notifications/promotions/:promotionId/edit",
    element: <EditPromo />,
  },
  {
    path: "/notifications/announcements",
    element: <Announcements />,
  },
  {
    path: "/notifications/announcements/:announcementId",
    element: <AnnouncementDetails />,
  },
  {
    path: "/notifications/announcements/create",
    element: <CreateAnnouncement />,
  },
  {
    path: "/notifications/announcements/:announcementId/edit",
    element: <EditAnnouncement />,
  },
];
